// extracted by mini-css-extract-plugin
module.exports = {"backgroundCircle":"styles_backgroundCircle__3z-f3","meterCircle":"styles_meterCircle__2v6oz","progress":"styles_progress__Vtpuj"};